"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var states_1 = require("../../../common/constants/states");
var CompleteSetupController = /** @class */ (function () {
    function CompleteSetupController(FlashService, UsersModel, UserService, $rootScope) {
        this.FlashService = FlashService;
        this.UsersModel = UsersModel;
        this.UserService = UserService;
        this.$rootScope = $rootScope;
        this.studentsModel = UsersModel;
        this.studentService = UserService;
        this.states = states_1.States;
        this.setupData = {};
        this.$rootScope = $rootScope;
        this.submitted = false;
        this.stateRequiresPermit =
            this.state === "CA" ||
                this.state === "GA" ||
                this.state === "PA" ||
                this.state === "MO" ||
                this.state === "KY" ||
                this.state === "NY" ||
                this.state === "AZ" ||
                this.state === "CO" ||
                this.state === "OK";
        this.userNeedsPickupLocation = this.userNeedsPickupLocation.bind(this);
        this.submitSetup = this.submitSetup.bind(this);
    }
    CompleteSetupController.prototype.userNeedsPickupLocation = function () {
        return this.student.pickuplocations.length === 0;
    };
    CompleteSetupController.prototype.submitSetup = function () {
        var _this = this;
        this.submitted = true;
        var data = {};
        if (this.setupData.location &&
            this.setupData.location.street &&
            this.setupData.location.city &&
            this.setupData.location.state &&
            this.setupData.location.zip) {
            data.pickuplocation = {
                street: this.setupData.location.street,
                city: this.setupData.location.city,
                state: this.setupData.location.state,
                zip: this.setupData.location.zip,
            };
        }
        if (this.setupData.permit &&
            this.setupData.permit.number &&
            this.setupData.permit.issuedate &&
            this.setupData.permit.expirationdate) {
            data.permit = {
                number: this.setupData.permit.number,
                issue_date: (0, time_1.toYMD)((0, time_1.parseMMDDYYYYDate)(this.setupData.permit.issuedate)),
                expiration_date: (0, time_1.toYMD)((0, time_1.parseMMDDYYYYDate)(this.setupData.permit.expirationdate)),
            };
        }
        this.studentsModel
            .completeStudentSetup(this.student.id, data)
            .then(function (response) {
            _this.submitted = false;
            _this.student.setup_complete = true;
            if (response.message) {
                _this.FlashService.setMessage({
                    message: response.message,
                    type: "success",
                });
            }
            var user = _this.studentService.getCurrentUser();
            if (user.role.type === "student") {
                user.setup_complete = true;
                _this.studentService.setCurrentUser(user);
            }
            if (user.role.type !== "student") {
                _this.$rootScope.$broadcast("STUDENT_SETUP_COMPLETE", {
                    home_address: data.pickuplocation,
                });
            }
        })
            .catch(function (response) {
            _this.submitted = false;
        });
    };
    return CompleteSetupController;
}());
CompleteSetupController.$inject = [
    "FlashService",
    "UsersModel",
    "UserService",
    "$rootScope",
];
exports.default = CompleteSetupController;
